import { render } from "./leftMenu.vue?vue&type=template&id=18e8735b&ts=true"
import script from "./leftMenu.vue?vue&type=script&lang=ts"
export * from "./leftMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__